import React, { useContext, useEffect, useRef, useState } from "react";
import "./Style.css";
import "./InfluencerDashboard.css";
import './BusinessPages/Additional.css'
import PageName from "../Utils/PageName";
import axios from "axios";
import { userContext } from "../../context/userContext";
import { environmentVariables } from "../../config/env.config";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "./Updatedcss/UpdatedDashboardstyle.css";
import { businessObjContext } from "../../context/businessObjContext";
import CircularLoader from "../Components/CircularLoader/CircularLoader";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import SortIcon from "@material-ui/icons/ArrowDownward";
import DataTable from "react-data-table-component";
import Dialog from '@mui/material/Dialog';
import TooltipImg from "./../../Images/info.png";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import { useTranslation } from "react-i18next";
import NewFilterIcon from "../../../src/Images/newFilter.svg";
import { CalenderDrawer } from "../Components/DateTimeFormat/CalenderDrawer";
import CalendarFilter from "../Components/DateTimeFormat/CalenderPopup";
import { getCurrencyDataByCurrency } from "../../utils/utility";

function Userpayinpayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [cardsData, setCardsData] = useState(null);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [planExpireDays, setPlanExpireDays] = useState(0);
  const [isStatus, setIsStatus] = useState(false);
  const [showPlanExpireBanner, setShowPlanExpireBanner] = useState(false);
  const { userData } = useContext(userContext);

  const [open, setOpen] = useState(false);
  const [storedData, setStoredData] = useState(
    localStorage.getItem("businessObj")
  );
  const httpProtocol = environmentVariables?.httpProtocol;
  const fronturl = environmentVariables?.frntUrl;
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const { businessObjData, setBusinessObjData } =
    useContext(businessObjContext);
  let busiObj = localStorage.getItem("businessObj");
  const [appointments, setAppointments] = useState([]);
  const [appData, setAppData] = useState([]);
  const [contData, setContData] = useState([]);
  const [chartsRs, setChartsRs] = useState([]);
  const [businessLink, setBusinessLink] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [sevdays, setSevdays] = useState({});
  const [busData, setBusData] = useState({});
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [claimAmount, setClaimAmount] = useState(0);
  const [withrawAmount, setWithdrawAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [influencerData, setInfluencerData] = useState(null);
  const tableExtensions = { export: false, print: false };
  const [youtubeSubscribe, setYoutubeSubscribe] = useState("")
  const [youtubeName, setYoutubeName] = useState("")
  const [GreatingMsg, setGreatingMsg] = useState("");
  const [openRemarks, setOpenRemarks] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState("");
  const [selectedDashDateFrom, setSelectedDashDateFrom] = useState("");
  const [selectedDashDateTo, setSelectedDashDateTo] = useState("");
  const [filter, setFilter] = useState(false);
  const [totalPayin, setTotalPayin] = useState(0);
  const [totalPayout, setTotalPayout] = useState(0);
  const [totalClaimable, setTotalClaimable] = useState(0);
  const [totalSettlementFee, setTotalSettlementFee] = useState(0);
  const [totalSettlementtxn, setTotalSettlementtxn] = useState(0);
  const [totalPayintxn, setTotalPayintxn] = useState(0);
  const [totalPayoutFee, setTotalPayoutFee] = useState(0);
  const [totalPayouttxn, setTotalPayouttxn] = useState(0);
  const [customClaimAmount, setCustomClaimAmount] = useState(0);
  const [totalPayinwithoutFilter, setTotalPayinwithoutFilter] = useState(0);
  const [totalPayoutwithoutFilter, setTotalPayoutwithoutFilter] = useState(0);
  const [unsettledwithoutFilter, setUnsettledwithoutFilter] = useState(0);
  const [payoutPopup, setPayoutPopup] = useState(false);
  const [accountNumber, setaccountNumber] = useState('');
  const [ifsc, setIfsc] = useState('');


  const [graphData, setGraphData] = useState({
    transformedData: [],
    gData2: [],
  });
  async function getGreatingMsg() {
    try {
      const response = await axios.get(
        `${baseUrl}api/v1/admin/setting/fetchConfig`,
        {
          params: {
            cnf_type: "Web",
            name: ["Influencer_Greeting"],
          },
        }
      );
      if (response.status === 200) {
        setGreatingMsg(response?.data?.result?.Influencer_Greeting);
      }
    } catch (error) {
      console.error({ "Error:": error, msg: "ErrorLanding" });
    }
  }
  const baseUrl = environmentVariables?.apiUrl;

  useEffect(() => {
    getInfluencerDashboardData()
    fetchClaimrequest(1);
  }, [selectedDashDateFrom, selectedDashDateTo]);


  const getInfluencerDashboardData = () => {
    let buzzData = !!storedData ? JSON.parse(storedData) : "";
    let shipCountry = !!buzzData ? buzzData?.shipCountry : "";
    axios
      .get(`${baseUrl}api/v1/custompayment/getBusinessownerpaymentSummaryById`, {
        params: { id: userData?.id, from_date: selectedDashDateFrom, to_date: selectedDashDateTo, country: shipCountry },
        headers: {
          _token: userData?.token,
        },
      })
      .then((res) => {
        if (res?.status === 200) {
          setTotalPayin(res?.data?.result?.consolidatedData?.payin_amount || 0);
          setTotalPayintxn(res?.data?.result?.consolidatedData?.payin_count || 0);
          let showPayout = Number(res?.data?.result?.consolidatedPayoutData?.payout_amount) - Number(res?.data?.result?.consolidatedPayoutData?.payout_fee);
          setTotalPayout(showPayout || 0);
          setTotalPayoutFee(res?.data?.result?.consolidatedPayoutData?.payout_fee || 0);
          setTotalPayouttxn(res?.data?.result?.consolidatedPayoutData?.payout_count || 0);
          let claimableData = res?.data?.result?.payinWalletData;
          setTotalClaimable(claimableData);
          setCustomClaimAmount(claimableData);
          setTotalSettlementFee(res?.data?.result?.consolidatedData?.settled_fee);
          setTotalSettlementtxn(res?.data?.result?.consolidatedData?.settled_count);
          setCurrencySymbol(res?.data?.result?.currency);
          setTotalPayinwithoutFilter(res?.data?.result?.payinWalletData || 0);
          let payoutData = res?.data?.result?.payoutWalletData || 0;
          setTotalPayoutwithoutFilter(payoutData);
          setWithdrawAmount(payoutData)
          setUnsettledwithoutFilter(res?.data?.result?.unsettledAmountData || 0);
          let claimableAmount = Number(res?.data?.result?.consolidatedData?.settled_amount) - Number(res?.data?.result?.consolidatedData?.settled_fee);
          setClaimAmount(claimableAmount)
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          console.error("Resource not found:", error);
        } else {
          console.error("error:", error);
        }
      });
  };

  let data1 = graphData?.transformedData;
  let data2 = [["Language", "Speakers (in millions)"]];
  data2.push(...graphData.gData2);
  const setBusinessDataLink = (buzzData) => {
    const businessData = JSON.parse(buzzData);
    let redirectUrl = (businessData?.slug_subdomain != null) ? httpProtocol + businessData?.slug_subdomain : (businessData?.slug != null) ? fronturl + businessData?.slug : "/";
    setBusinessLink(`${redirectUrl}`);
    setBusinessName(businessData?.title);
  }
  useEffect(() => {
    getInfluencerDashboardData();
    getGreatingMsg();
    if (storedData != "undefined" && storedData != null) {
      setBusinessDataLink(storedData);
    } else {
      setBusinessDataLink(busiObj);
    }
  }, [storedData, busiObj]);

  const apiUrl = environmentVariables?.apiUrl;

  useEffect(() => {
    let config = {
      method: "get",
      url: `${apiUrl}api/v1/user/getDashboardData`,
      headers: {
        _token: userData?.token,
      },
    };

    axios
      .request(config)
      .then((response) => {
        setCardsData(response?.data?.data);
      })
      .catch((error) => {
        if (error?.response?.status) {
          localStorage.clear();
          window.location.href = "/";
          window.location.reload();
        }
      });
  }, []);

  const fetchApppointent = (page = 1) => {
    try {
      let obj = {
        business_id: businessObjData?.id,
      };
      axios
        .post(`${baseUrl}api/v1/appointment/FetchAppointments_withpagination?page=${page}&limit=${rowsPerPage}&showcount=${userData?.appointments}`, { ...obj }, {
          headers: {
            _token: userData?.token,
          },
          withCredentials: true,
        })
        .then((response) => {
          let arr = response?.data?.data?.records;
          arr = arr.sort(
            (x, y) => new Date(y?.created_at) - new Date(x?.created_at)
          );
          setAppointments(arr);
        })
        .catch((error) => {
        });
    } catch (err) {
      console.log(err, "erroror");
    }
  };


  useEffect(() => {
    fetchApppointent();
  }, [rowsPerPage]);

  const handleResetDash = () => {
    setSelectedDashDateFrom("");
    setSelectedDashDateTo("");
  };

  const fetchClaimrequest = async (page, size = perPage) => {
    try {
      axios
        .get(`${baseUrl}api/v1/custompayment/getAllClaimRequestByboId?id=${userData?.id}&from_date=${selectedDashDateFrom}&to_date=${selectedDashDateTo}&page=${page}&per_page=${size}`)
        .then((response) => {
          console.log("response1111111", response);
          setData(response?.data?.result);
          setTotalRows(response.data.totalRows);
          setCurrentPage(response.data.currentPage);
          setIsLoading(false)

        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false)
        });
    } catch (err) {
      setData([])
      setIsLoading(false)
    }
  };

  const handleClickOpen = () => {
    ((totalClaimable) === 0 || !!data && data?.length > 0 && data[0]?.payment_status == 'pending' || (totalClaimable) < 100) ? setOpen(false) :
      setOpen(true);
  };

  const handlePayout = () => {
    if (payoutPopup == true) {
      setPayoutPopup(!payoutPopup);
    } else {
      ((totalPayoutwithoutFilter) === 0 || !!data && data?.length > 0 && data[0]?.payment_status == 'pending' || (totalPayoutwithoutFilter) < 100) ? setPayoutPopup(false) : setPayoutPopup(true);
    }
  };



  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    fetchClaimrequest(1);
  }, [])

  // const CalendarComponent = ({ appointments }) => {
  // Transform appointment data into the format expected by FullCalendar
  const events = appointments.map(appointment => ({
    title: appointment.businessTitle, // Use businessTitle as the event title
    start: appointment.date, // Use date as the event start time
    // You can optionally include other properties such as 'end' here if needed
    extendedProps: {
      // Pass the entire appointment object as extendedProps
      appointment,
    },

  }));

  useEffect(() => {
    getExpirationDetails();
  }, []);

  const getExpirationDetails = () => {
    let config = {
      method: "get",
      url: `${apiUrl}api/v1/user/getPlanExpirationDetails`,
      headers: {
        _token: userData?.token,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response?.data?.success) {
          setPlanExpireDays(response?.data?.planExpiryDays);
          setShowPlanExpireBanner(response?.data?.allowToShowExpiryBanner);
        }
      })
      .catch((error) => {
        console.log("error====>>>", error.message);

      });
  }

  console.log("currencySymbol:", currencySymbol);

  const ClaimHandler = () => {
    setIsStatus(true);
    if (!Number(customClaimAmount) || customClaimAmount <= 0) {
      setIsStatus(false);
      toast.error("Requested amount must be a pasitive number.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    } else if (Number(customClaimAmount) < 100) {
      setIsStatus(false);
      toast.error("Requested amount should be greater than or equal to 100.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    } else if (customClaimAmount > totalClaimable) {
      setIsStatus(false);
      toast.error("Requested amount must be less than claimable amount", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    } else {
      let data = {
        user_id: userData.id,
        requested_amount: String(customClaimAmount),
        requested_currency: currencySymbol
      }
      axios.post(`${baseUrl}api/v1/custompayment/custompayClaimRequest`, data)
        .then((res) => {
          setIsStatus(false);
          console.log(res, "Claim request response");
          setClaimAmount(res?.data?.result);
          toast.success(t("Claim_request_created"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          });
          fetchClaimrequest(1);
          getInfluencerDashboardData();
          handleClose();
        }).catch((error) => {
          setIsStatus(false);
          toast.error(error.response?.data?.message || t("An_error_occurred"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          });
          handleClose();
        })
    }
  }

  const hideModal = () => {
    // if (closeButtonRef.current) {
    //   $(closeButtonRef.current).trigger("click");
    // }
    setOpenRemarks(false);
    setSelectedMessage("");
    // setIsModalOpen(false);
  };


  const handleViewMessage = (d) => {
    setOpenRemarks(true);
    setSelectedMessage(d);
  };


  function useWindowWidth() {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return width;
  }


  const windowWidth = useWindowWidth();

  const getStatusStyle = (status) => {
    const styles = {
      failed: { color: "#e71c1f", background: "#e71c1f33" },
      pending: { color: "#ffa401", background: "#ffa40133" },
      completed: { color: "#2892D5", background: "#2892D533" },
      settled: { color: "#26a56a", background: "#26a56a33" },
      transaction_not_paid_yet: { color: "#ff6600", background: "#ff660033" },
    };

    const { color = "#000", background = "#00000033" } = styles[status] || {};

    return {
      fontWeight: "500",
      color,
      background,
      borderRadius: "4px",
      padding: "2px 0px",
      textTransform: "capitalize",
      minWidth: "90px",
      maxWidth: "90px",
      display: "block",
      textAlign: "center",
    };
  };


  const columns = [
    {
      name: t("Payment_request"),
      selector: (row) => {
        const date = new Date(row.created_at);
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return date.toLocaleString('en-US', options);
      },
      cell: (row) => {
        const date = new Date(row.created_at);
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return (
          <div className="custom-cell" data-column-name={t("Payment_request")}>
            {date.toLocaleString('en-US', options)}
          </div>
        );
      },
      sortable: true,
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },
    {
      name: t("Requested_amount"),
      selector: (row) => {
        const amount = row.requested_amount ?? "--";
        if (currencySymbol === "د." || currencySymbol === "AED") {
          return `${amount} ${currencySymbol}`;
        } else {
          return `${getCurrencyDataByCurrency(currencySymbol)}${amount}`;
        }
      },
      cell: (row) => (
        <div className="custom-cell" data-column-name={t("Requested_amount")}>
          {currencySymbol === "د." || currencySymbol === "AED" ? row.requested_amount + " " + currencySymbol : getCurrencyDataByCurrency(currencySymbol) + row.requested_amount || "--"}
        </div>
      ),
      sortable: true,
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },
    {
      name: t("Receivable"),
      selector: (row) =>
        row.payment_status === "failed" || row.payment_status === "pending"
          ? (currencySymbol === "د." || currencySymbol === "AED") ? row.paid_amount + row.requested_currency : getCurrencyDataByCurrency(row.requested_currency) + row.paid_amount 
          : "0",
      cell: (row) => (
        <div className="custom-cell" data-column-name="Amount to Pay">
          {row.payment_status === "failed" || row.payment_status === "pending"
            ? (currencySymbol === "د." || currencySymbol === "AED") ? row.paid_amount + row.requested_currency : getCurrencyDataByCurrency(row.requested_currency) + row.paid_amount
            : "0"}
        </div>
      ),
      sortable: true,
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },
    {
      name: t("Received_amount"),
      selector: (row) =>
        row.payment_status === "failed" || row.payment_status === "pending"
          ? "0" : (currencySymbol === "د." || currencySymbol === "AED") ? row.paid_amount + row.requested_currency : getCurrencyDataByCurrency(row.requested_currency) + row.paid_amount,
      cell: (row) => (
        <div className="custom-cell" data-column-name="Amount to Pay">
          {row.payment_status === "failed" || row.payment_status === "pending"
            ? "0" : (currencySymbol === "د." || currencySymbol === "AED") ? row.paid_amount + row.requested_currency : getCurrencyDataByCurrency(row.requested_currency) + row.paid_amount}
        </div>
      ),
      sortable: true,
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },
    {
      name: t("Payment_status"),
      selector: (row) =>
        row.payment_status == "failed" ? "Cancel" : row.payment_status,
      cell: (row) => (
        <div className="custom-cell" data-column-name={t("Payment_status")}>
          <span style={getStatusStyle(row.payment_status)}> {row.payment_status == "failed" ? "Cancel" : row.payment_status}</span>
        </div>
      ),
      sortable: true,
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },
    {
      name: t("Remarks"),
      sortable: true,
      cell: (row) => (
        <div className="custom-cell" data-column-name={t("Remarks")}>
          {row.payment_remarks ? (
            <i
              className="first fas fa-eye"
              onClick={() => handleViewMessage(row)}
              style={{ cursor: "pointer", marginRight: "10px" }}
            ></i>
          ) : (
            "--"
          )}
        </div>
      ),
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },
  ];


  const customStyles = {

    headRow: {
      style: {
        display: "flex",
        alignItems: "stretch",
        width: "100%",
        backgroundColor: "#E9E9E9",
        minHeight: "52px",
        borderRadius: "2px 2px 0px 0px",
        padding: "8px 25px",
        border: "none",

      },
    },
    headCells: {
      style: {
        color: "#525252",
        fontSize: "16px",
        minHeight: "52px",
        fontSize: "15px",

      },
    },
    rows: {
      style: {
        padding: "20px 25px",
        fontSize: "14px",
        textTransform: "capitalize",
        minHeight: "48px ",
      },
    },
    pagination: {
      style: {
        borderTop: windowWidth > 768 ? "1px solid #0000001f" : "0",
      },
    },
  };

  const tableData = {
    columns,
    data,
  };
  const paginationOptions = {
    rowsPerPageText: t("Rows_per_page"),
    rangeSeparatorText: t("Of"),
    selectAllRowsItem: false,
    // selectAllRowsItemText: t("All"),
  };

  const handlePageChange = (page) => {
    fetchClaimrequest(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    fetchClaimrequest(page, newPerPage);
  };

  const handleFilter = () => {
    setFilter(!filter)
  }

  const handleDateFilter = (date) => {
    if (
      date &&
      date.from instanceof Date &&
      !isNaN(date.from) &&
      date.to instanceof Date &&
      !isNaN(date.to)
    ) {
      const fromDate = date.from.getTime();
      const toDate = date.to.getTime();

      setSelectedDashDateFrom(fromDate);
      setSelectedDashDateTo(toDate);
    }
    if (date == 'reset') {
      handleResetDash();
    }
  }



  return (
    <>
      <PageName PageName="Wallet Dashboard" />
      <div className="row Greeting_total_wrapper" id="custom_table">
        {!!data && data?.length > 0 && data[0]?.payment_status === 'pending' && (
          <div className="lastrequest lastrequest-payinout">

            <div className="lastrequesttext">
              {t("Last_request")}{" "}
              <span style={{ fontWeight: "700" }}>
                {currencySymbol === "AED"
                  ? `${data[0]?.requested_amount} ${currencySymbol}`
                  : `${getCurrencyDataByCurrency(currencySymbol)}${data[0]?.requested_amount}`}
              </span>{" "}
              {t("Under_process")}
            </div>
          </div>
        )}


        {/* <div className="col-md-7" id="total_wrapper_container"></div> */}
        <div className="col-md-12 walletDashboard" style={{ padding: "0" }}>
          <div className="row walletDashboardtop" >
            <div className="filterWrapper" style={{ marginBottom: "20px", marginTop: "10px", width: "100%", justifyContent: "space-between" }}>
              {
                userData?.walletStatus && userData?.walletPackageId ?
                <span className="walletplanbo"><i class="fa-solid fa-crown"></i> {userData?.walletPackageName} Plan </span>:''
              }
              {/* <div className=" SuperDashboardTop">
                <h3>Hello, {userData?.name?.split(" ")[0]}! 
                </h3>
                <h4>Stay on top of your Pay-in and Pay-out flow</h4>
               
              </div> */}


            </div>
            <div className="mainInOutCardWrapper ">
              <div className="row g-3" style={{ display: "flex" }}>
                <div className=" col-12 col-md-6" >
                  <div className="tile bbox" style={{ display: "flex", alignItems: "center", justifyContent: "start", gap: "20px" }}>
                    {/* background:"linear-gradient(45deg, #E91E63, #86bceb)" */}
                    <div className=" below-1400-none">
                      <i
                        class="fa-solid fa-money-bill-wave"
                        style={{ background: "rgb(251, 241, 255)", color: "rgb(158, 62, 191)", display: "flex" }}
                      ></i>
                    </div>
                    <div style={{ width: "100%" }}>
                      <div className="tooltip-wrapper">
                        <h3 className="tooltipcontainer_infdash">
                          {/* {t("Total_earning")}  */}
                          Pay-In
                          <div className="tooltipDiv">
                            <span className="tooltip-target"> <img loading="lazy" className="tooltipimg" src={TooltipImg} style={{ width: '18px' }} />  </span>
                            <span className="tooltip ">{t("Payin_tooltip")} {currencySymbol != "AED" && (currencySymbol) }100{currencySymbol == "AED" && ("AED")}</span></div>
                        </h3>
                      </div>
                      {/* <h4>{currencySymbol}{!!totalEarning ? Number(totalEarning)?.toFixed(2) :0 || 0}</h4> */}
                      <div className="Remainingclaimableamtdiv">
                      {currencySymbol !== "AED" ? (
                      <h4 className="Remainingclaimableamt" style={{ display: "flex", gap: "20px" }}>
                        {getCurrencyDataByCurrency(currencySymbol)}{(totalPayinwithoutFilter && totalPayinwithoutFilter > 0) ? Number(totalPayinwithoutFilter)?.toFixed(2) : '0.00'}   
                        <span className={((totalPayinwithoutFilter) === 0 || !!data && data?.length > 0 && data[0]?.payment_status == 'pending' || (totalPayinwithoutFilter) < 100) || userData?.walletStatus == 0 || !userData?.walletPackageId ? "disableclaimbtnspan" : "claimbtnspan"}
                          onClick={((totalPayinwithoutFilter) === 0 || !!data && data?.length > 0 && data[0]?.payment_status == 'pending' || (totalPayinwithoutFilter) < 100) || userData?.walletStatus == 0 || !userData?.walletPackageId ? null : handleClickOpen}
                        >
                          <button className="claimbtn"> {t("Claim")} </button>
                        </span>
                      </h4>
                    ) : (
                      <h4 className="Remainingclaimableamt" style={{ display: "flex", gap: "20px" }}>
                        {(totalPayinwithoutFilter && totalPayinwithoutFilter > 0) ? Number(totalPayinwithoutFilter)?.toFixed(2) : '0.00'} {currencySymbol}
                        <span className={((totalPayinwithoutFilter) === 0 || !!data && data?.length > 0 && data[0]?.payment_status == 'pending' || (totalPayinwithoutFilter) < 100) || userData?.walletStatus == 0 || !userData?.walletPackageId ? "disableclaimbtnspan" : "claimbtnspan"}
                        onClick={((totalPayinwithoutFilter) === 0 || !!data && data?.length > 0 && data[0]?.payment_status == 'pending' || (totalPayinwithoutFilter) < 100) || userData?.walletStatus == 0 || !userData?.walletPackageId ? null : handleClickOpen}
                        >
                          <button className="claimbtn"> {t("Claim")} </button>
                        </span>
                      </h4>
                    )}
                    </div>
                    </div>
                    {/* <p>25% of Total Sales</p> */}
                  </div>
                </div>
                <div className=" col-12 col-md-6 payOutWrapper">
                  <div className="tile bbox " style={{ display: "flex", alignItems: "center", justifyContent: "start", gap: "20px" }}>
                    <div className=" below-1400-none">
                      <i
                        class="fa-solid fa-money-bill-transfer "
                        style={{ background: "rgb(255, 239, 235)", color: "rgb(248, 124, 91)", display: "flex" }}
                      ></i>
                    </div>
                    <div style={{ width: "100%" }}>
                      <div className="tooltip-wrapper">
                        <h3 className="tooltipcontainer_infdash">

                          Pay-Out
                          <div className="tooltipDiv"><span className="tooltip-target"> <img loading="lazy" className="tooltipimg" src={TooltipImg} style={{ width: '18px' }} />  </span>
                            <span className="tooltip"
                            // style={{left:'89%', top:'-100%'}}

                            >{t("Payout_tooltip")}  {currencySymbol != "AED" && (currencySymbol) }1000{currencySymbol == "AED" && ("AED")}</span></div>
                        </h3>
                      </div>
                      <div className="Remainingclaimableamtdiv">
                      {currencySymbol !== "AED" ? (
                      <h4 className="Remainingclaimableamt" style={{ display: "flex", gap: "20px" }}>
                        {getCurrencyDataByCurrency(currencySymbol)}{(totalPayoutwithoutFilter && totalPayoutwithoutFilter > 0) ? Number(totalPayoutwithoutFilter)?.toFixed(2) : '0.00'}
                        
                      </h4>
                    ) : (
                      <h4 className="Remainingclaimableamt" style={{ display: "flex", gap: "20px" }}>
                        {(totalPayoutwithoutFilter && totalPayoutwithoutFilter > 0) ? Number(totalPayoutwithoutFilter)?.toFixed(2) : '0.00'} {currencySymbol}
                      </h4>
                    )}
                    </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>


            <div className="filterWrapper" style={{width:"100%", marginBottom:"10px"}}>
                 {windowWidth > 768 ? (
                <CalendarFilter t={t} handleDateFilter={handleDateFilter} />
              ) : (
                <>
                  <div className="FilterIcon user-filter" onClick={handleFilter}>
                    <div className="filtertext">{t("Filter")} <img loading="lazy" src={NewFilterIcon} width={28} /></div>
                  </div>
                  <CalenderDrawer filter={filter} handleFilter={handleFilter} handleDateFilter={handleDateFilter} t={t} />
                </>
              )}
            </div>

            <div className="mainInOutCardWrapper col-md-8 lowerCard" >
              <div className="row g-3" style={{ display: "flex" }}>
                <div className=" col-6 col-md-6" >
                  <div className="tile bbox unsettledCard" style={{ display: "flex", alignItems: "center", justifyContent: "start", gap: "20px" }}>
                    {/* background:"linear-gradient(45deg, #E91E63, #86bceb)" */}
                    <div className=" below-1400-none">
                      <i
                        // class="fa-solid fa-hand-holding-dollar"
                        class="fas fa-hourglass-half"
                        style={{ background: "rgb(251, 241, 255)", color: "rgb(158, 62, 191)", display: "flex" }}
                      ></i>
                    </div>
                    <div>
                      <div className="tooltip-wrapper">
                        <h3 className="tooltipcontainer_infdash">
                          {/* {t("Total_earning")}  */}
                          Unsettled
                          <div className="tooltipDiv">
                            <span className="tooltip-target"> <img loading="lazy" className="tooltipimg" src={TooltipImg} style={{ width: '18px' }} />  </span>
                            <span className="tooltip ">{t("Unsettled_tooltip")} </span></div>
                        </h3>
                      </div>
                      {/* <h4>{currencySymbol}{!!totalEarning ? Number(totalEarning)?.toFixed(2) :0 || 0}</h4> */}
                     {currencySymbol !== "AED" ? (
                      <h4>{getCurrencyDataByCurrency(currencySymbol)}{Number(totalPayin)?.toFixed(2) || 0}</h4>
                    ) : (
                      <h4>{Number(totalPayin)?.toFixed(2) || 0} {currencySymbol}</h4>
                    )}
                        <div className="fees"> <p>Total Txn: {totalPayintxn}</p></div>
                    </div>
                    {/* <p>25% of Total Sales</p> */}
                  </div>
                </div>
                <div className=" col-6 col-md-6">
                  <div className="tile bbox " style={{ display: "flex", alignItems: "center", justifyContent: "start", gap: "20px" }}>
                    <div className=" below-1400-none">
                      <i
                        class="fa-solid fa-money-bill"
                        style={{ background: "rgb(255, 239, 235)", color: "rgb(248, 124, 91)", display: "flex" }}
                      ></i>
                    </div>
                    <div>
                      <div className="tooltip-wrapper">
                        <h3 className="tooltipcontainer_infdash">

                          Settled
                          <div className="tooltipDiv"><span className="tooltip-target"> <img loading="lazy" className="tooltipimg" src={TooltipImg} style={{ width: '18px' }} />  </span>
                            <span className="tooltip"
                            // style={{left:'89%', top:'-100%'}}

                            >{t("Settled_tooltip")} </span></div>
                        </h3>
                      </div>
                      {/* <h4>{currencySymbol}{Number(withdrawn)?.toFixed(2) || 0}</h4> */}
                     {currencySymbol !== "AED" ? (
                        <h4>{getCurrencyDataByCurrency(currencySymbol)}{Number(claimAmount)?.toFixed(2) || 0}</h4>
                      ) : (
                        <h4>{Number(claimAmount)?.toFixed(2) || 0} {currencySymbol}</h4>
                      )}
                      <div className="fees"> 
                        {currencySymbol !== "AED" ? (
                          <p>Fees:  {getCurrencyDataByCurrency(currencySymbol)}{Number(totalSettlementFee)?.toFixed(2) || 0}</p>
                        ) : (
                          <p>Fees:  {Number(totalSettlementFee)?.toFixed(2) || 0} {currencySymbol} </p>
                        )}
                      |
                      <p>Total Txn: {totalSettlementtxn}</p>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>

            <div className="col-md-4 lowerCard">
              <div className="tile bbox " style={{ display: "flex", alignItems: "center", justifyContent: "start", gap: "20px" }}>
                <div className=" below-1400-none">
                  <i
                    class="fa-solid fa-money-bill-transfer "
                    style={{ background: "rgb(243, 241, 255)", color: "rgb(81, 69, 158)", display: "flex" }}
                  ></i>
                </div>
                <div style={{ width: "100%" }}>
                  <div className="tooltip-wrapper">
                    <h3 className="tooltipcontainer_infdash">
                      {/* {t("Total_claimable_amount")}  */}
                      Pay-Out
                      <div className="tooltipDiv"><span className="tooltip-target"> <img loading="lazy" className="tooltipimg" src={TooltipImg} style={{ width: '18px' }} />  </span>
                        <span className="tooltip"
                        //  style={{top:'-100%',left:'90%'}}
                        >{t("Payout_tooltip")} {currencySymbol != "AED" && (currencySymbol) }1000{currencySymbol == "AED" && ("AED")}</span></div>
                    </h3>
                  </div>
                  <div className="Remainingclaimableamtdiv">
                     {currencySymbol !== "AED" ? (
                      <h4>{getCurrencyDataByCurrency(currencySymbol)}{Number(totalPayout)?.toFixed(2) || 0}</h4>
                    ) : (
                      <h4>{Number(totalPayout)?.toFixed(2) || 0} {currencySymbol}</h4>
                    )}
                      <div className="fees"> 
                        {currencySymbol !== "AED" ? (
                          <p>Fees: {getCurrencyDataByCurrency(currencySymbol)}{Number(totalPayoutFee)?.toFixed(2) || 0} </p>
                        ) : (
                          <p>Fees: {Number(totalPayoutFee)?.toFixed(2) || 0} {currencySymbol} </p>
                        )}
                      |
                     <p>Total Txn: {totalPayouttxn}</p></div>
                  </div>
                </div>
              </div>
            </div>
          </div>



          <div className="main inf_dash walletMobileTable">
            <h3 className="payin-payout-request-heading">{t("Claim_request_list")}</h3>
            {isLoading ? (
              <CircularLoader size={40} />
            ) : (
              <DataTableExtensions
                {...tableData}
                filterPlaceholder="Search Coupon"
                customStyles={customStyles}
                {...tableExtensions}
                className="extensionscls"
              >
                <DataTable
                  columns={columns}
                  data={data}
                  noHeader
                  defaultSortField="id"
                  sortIcon={<SortIcon />}
                  defaultSortAsc={true}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationRowsPerPageOptions={[10, 15, 20, 25, 30]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  dense
                  progressPending={isLoading}
                  paginationComponentOptions={{
                    ...paginationOptions,
                  }}
                  customStyles={customStyles}
                  noDataComponent={<div style={{ padding: "24px" }}>{t("No_records_found")}</div>}
                />
              </DataTableExtensions>
            )}
          </div>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <div className="claimablepopbox customClaim">
              <h3>{t("Confirm_payout_request")}</h3>
              <div className="requestpopbox">
                <h4>{t("Total_earning")}</h4>
                {currencySymbol !== "AED" ? (
                  <h5>{getCurrencyDataByCurrency(currencySymbol)}{!!totalPayinwithoutFilter ? Number(totalPayinwithoutFilter)?.toFixed(2) : 0 || 0}</h5>
                ) : (
                  <h5>{!!totalPayinwithoutFilter ? Number(totalPayinwithoutFilter)?.toFixed(2) : 0 || 0} {currencySymbol}</h5>
                )}
              </div>
              <div className="requestpopbox">
                <h4>{t("Total_claimable_amount")} </h4>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <h5 style={{ padding: "0"}}>{getCurrencyDataByCurrency(currencySymbol)}</h5>
                  <input
                    type="number"
                    min="100"
                    max={totalClaimable}
                    style={{ padding: "0", fontSize :"20px", fontFamily:"Jost" }}
                    value={customClaimAmount}
                    onChange={(e) => {
                      const value = e.target.value;
                      setCustomClaimAmount(
                        value > totalClaimable ? totalClaimable : value
                      );
                    }}
                  />
                </div>
              </div>
              <div className="requestpayout" onClick={ClaimHandler} autoFocus>
                {isStatus ? (
                  <CircularLoader size={20} />
                ) : (
                  t("Request_for_payout")
                )}
              </div>
              <div className="requestpayoutcancel" onClick={handleClose}>{t("Cancel")}
              </div>
            </div>
          </Dialog>
          <Modal
            aria-labelledby="modal-title"
            aria-describedby="modal-desc"
            open={openRemarks}
            onClose={() => hideModal()}
            // onClose={() => setOpen(false)}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          // style={{ outline: "none" }}
          // style={{overflow:"scroll", outline:"none"}}
          >
            <Sheet
              variant="outlined"
              sx={{
                maxWidth: 500,
                minWidth: 390,
                borderRadius: "md",
                boxShadow: "lg",
                maxHeight: 300, // Limit the height
                overflow: "auto", // Enable scrolling if content exceeds height
                p: 2, // Reduce padding
              }}
              className="Infproductdetails"
            >
              <ModalClose variant="plain" sx={{ m: 1 }} />
              <Typography
                component="h2"
                id="modal-title"
                level="h4"
                textColor="inherit"
                fontWeight="lg"
                mb={2}
                textAlign="center"
              >
                {t("Remarks")}
              </Typography>

              <div>
                <div>{selectedMessage?.payment_remarks}</div>
              </div>
            </Sheet>
          </Modal>
        </div>
      </div>
    </>
  );
}
export default Userpayinpayout;
//1112